import { Component, Inject, Input, SimpleChanges } from "@angular/core";
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { REGISTRY_APPLICATION } from "../../../../../global/tokens";

@Component({
  selector: "app-glp-usage-chart",
  templateUrl: "./glp-usage-chart.component.html",
  styleUrls: ["./glp-usage-chart.component.scss"],
})
export class GlpUsageChartComponent {
  @Input() dataInsight: any;
  public loading:boolean=true

  constructor(
    @Inject(REGISTRY_APPLICATION) public application: string,
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.application === 'Admin'){
      if (changes['dataInsight'] && changes['dataInsight'].firstChange) {
        this.createPieChart();
      this.loading=false
      }
    }else{
      if (changes['dataInsight'] && !changes['dataInsight'].firstChange) {
        this.createPieChart();
      this.loading=false
      }
    }
  }

  createPieChart() {
    // Reverse the data for the pie chart
    const data = [...this.dataInsight?.glp_1_usage_data].reverse();
    const labels = data;
    const values = data;

    // Index value to match the highlihtedBox
    const indexValue = this.dataInsight?.index;

    const canvas: any = document.getElementById("glpPieChart");
    const ctx = canvas.getContext("2d");
    canvas.width = canvas.offsetWidth;
    canvas.height = 240;
    Chart.defaults.global.defaultFontFamily= 'Poppins, sans-serif'
    const chart = new Chart(ctx, {
        type: "pie",
        plugins: [ChartDataLabels],
        options: {
            tooltips: {
                backgroundColor: "white",
                titleFontColor: "#000",
                bodyFontColor: "#000",
                borderColor: "#ccc",
                borderWidth: 1,
                titleFontSize:window.innerWidth < 768 ? 12 : 18,
                bodyFontSize:window.innerWidth < 768 ? 12 : 16,
                callbacks: {
                    label: function (tooltipItem, data) {
                        const totalNumber = [...this.dataInsight?.glp_count].reverse();
                        const total = totalNumber[tooltipItem.index];
                        return `${total} (${data.datasets[0].data[tooltipItem.index].toString()}%)`;
                    }.bind(this),
                },
            },
            responsive: true,
            plugins: {
                datalabels: {
                  color: (context) => {
                    const index = context.dataIndex;
                    const swappedIndex = index === 0 ? 1 : index === 1 ? 0 : index;
                    return swappedIndex === indexValue ? "rgba(81,103,163,1)" : "#fff";
                },
                backgroundColor: (context) => {
                  const index = context.dataIndex;
                  const swappedIndex = index === 0 ? 1 : index === 1 ? 0 : index;
                  return swappedIndex === indexValue ? "#fff" : null;
                },
                borderRadius: 5,
                    font: {
                        size:window.innerWidth < 768 ? 14 : 17,
                        weight: 500,
                    },
                    formatter: (value: number) => {
                        return `${value}%`;
                    },
                },
            },
            legend: {
                display: false,
            },
            title: {
                display: true,
                fontSize: 30,
            },
        },
        data: {
            labels: labels,
            datasets: [
              {
                data: values,
                backgroundColor:["rgba(81,103,163,1)", "rgba(82,202,224,1)"],
                borderWidth: 0,
              },
            ],
        },
    });
}
  
}
